import classNames from "classnames/bind";
import styles from "./ModalCarpark.module.css";
import { Modal, Space, Typography } from "antd";
import CanvasDraw from "./CanvasDraw";
import { useEffect, useState } from "react";


const cx = classNames.bind(styles);

function ModalCarpark({ info, handleClose }) {
    const [detail, setDetail] = useState({});

    const handleSetUpInfo = (info) => {
        const infoRegion = {
            height: info?.height_image || 1080,
            width: info?.width_image || 1920,
            path: process.env.REACT_APP_FSR_EVENT + info?.path,
            polygon: info?.list_object_detail,
            key_point: info?.key_point || [],
            temprature: info?.temprature || false,
            pointList: info?.point_list || []
        }
        setDetail(infoRegion);
    }

    useEffect(() => {
        handleSetUpInfo(info);
    }, [info])

    return (
        <Modal
            open={info?.isShow}
            onCancel={handleClose}
            footer={<></>}
            centered
            className={cx('modal')}
        >
            <div className={cx('image')} >
                <CanvasDraw polygon={detail} preview={info?.preview} />
                {detail?.temprature && <Typography.Title className={cx('temprature')}>{detail?.temprature} °C</Typography.Title>}
            </div>
        </Modal>
    )
}

export default ModalCarpark;